import React, { useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { Link } from "react-router-dom";
import { Box, Button, Text, Flex, Container, Heading, useColorModeValue, useTheme, HStack } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionHeading = motion(Heading);
const MotionText = motion(Text);
const MotionButton = motion(Button);

const divStyle = {
  display: "flex",
  alignItems: "center",
  backgroundSize: "cover",
  height: "600px",
  position: "relative",
  backgroundPosition: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust overlay opacity as needed
  }
};

// You can replace these with your actual image URLs and captions
const slideImages = [
  {
    url: "https://www.shutterstock.com/image-photo/ai-technology-artificial-intelligence-man-260nw-2263545623.jpg",
    caption: "Innovative Technology Solutions",
  },
  {
    url: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80",
    caption: "Digital Transformation",
  },
  {
    url: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80",
    caption: "Future-Ready Solutions",
  },
];

// You can customize these messages for each slide
const messages = [
  {
    title: "Transform Your Business",
    subtitle: "With Cutting-Edge Technology",
  },
  {
    title: "Innovate & Scale",
    subtitle: "Your Digital Success Story",
  },
  {
    title: "Future-Ready Solutions",
    subtitle: "For Tomorrow's Challenges",
  },
];

const HeaderFirst = ({ onBookAppointmentClick }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const theme = useTheme();
  const primaryColor = theme.colors.brand[500];
  const secondaryColor = theme.colors.accent[500];

  // Animation variants
  const fadeInScale = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1 }
  };

  return (
    <Box position="relative">
      <Slide
        onChange={(from, to) => setCurrentSlide(to)}
        autoplay={true}
        duration={5000}
        transitionDuration={1000}
        // You can add other props here for navigation arrows, indicators, etc.
      >
        {slideImages.map((slideImage, index) => (
          <div key={index}>
            <div
              style={{ ...divStyle, backgroundImage: `url(${slideImage.url})` }}
            >
              {/* Overlay */}
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="rgba(0, 0, 0, 0.6)" // Slightly darker overlay for better contrast
              />
              <Container maxW="container.xl" position="relative" zIndex={1} textAlign="center">
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  h="600px" // Match divStyle height
                  color="white"
                  maxW="1000px" // Adjust max width for text container
                  mx="auto" // Center the text container
                  px={4}
                >
                  <MotionHeading
                    as="h1"
                    fontSize={{ base: "4xl", md: "6xl", lg: "7xl" }}
                    fontWeight="extrabold"
                    mb={4}
                    lineHeight="1.1"
                    bgGradient={`linear(to-r, ${primaryColor}, ${secondaryColor})`}
                    bgClip="text"
                    color="transparent"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInScale}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    textShadow="4px 4px 8px rgba(0,0,0,0.8)"
                    letterSpacing="tight"
                  >
                    {messages[index].title}
                  </MotionHeading>
                  <MotionText
                    fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
                    mb={8}
                    opacity={1}
                    initial="hidden"
                    animate="visible"
                    variants={fadeInScale}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    maxW="800px"
                    lineHeight="1.5"
                    textShadow="1px 1px 3px rgba(0,0,0,0.4)"
                    letterSpacing="normal"
                  >
                    {messages[index].subtitle}
                  </MotionText>
                  <HStack spacing={4}> {/* Wrap buttons in HStack */}
                    <MotionButton
                      size="lg"
                      colorScheme="purple"
                      bg={primaryColor} // Use primary color from theme
                      _hover={{ bg: secondaryColor }} // Use secondary color from theme
                      px={10}
                      py={6} // Add vertical padding for larger button
                      fontSize="xl"
                      initial="hidden"
                      animate="visible"
                      variants={fadeInScale}
                      transition={{ duration: 0.8, delay: 0.6 }}
                      boxShadow="lg"
                      _active={{ bg: secondaryColor }}
                      onClick={onBookAppointmentClick} // Added onClick handler
                    >
                      Book Appointment
                    </MotionButton>
                  </HStack>
                </Flex>
              </Container>
            </div>
          </div>
        ))}
      </Slide>
    </Box>
  );
};

export default HeaderFirst;
